/**
 * Ask the browser to confirm leaving while any cart still holds items:
 * closing the tab mid-shop is the easiest way to abandon a basket. Browsers
 * show their own generic "Leave site?" dialog on a cancelled beforeunload
 * (custom message text has been ignored by every modern browser, by design),
 * which is exactly the "are you sure you don't want to check out?" moment.
 *
 * The prompt only appears when itemCount() > 0, so guests and empty-cart
 * shoppers close the tab freely. Returns an uninstaller (tests, hot reload).
 */
export function installExitGuard(win: Window, itemCount: () => number): () => void {
  const handler = (e: BeforeUnloadEvent): void => {
    if (itemCount() > 0) {
      e.preventDefault();
      // Chromium additionally requires returnValue to be set.
      e.returnValue = "";
    }
  };
  win.addEventListener("beforeunload", handler);
  return () => win.removeEventListener("beforeunload", handler);
}
